(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["section"] && !Shopify.designMode) return;
  try {
    (function () {
    if (!('IntersectionObserver' in window)) return;
    const targets = document.querySelectorAll('[data-scroll-animate]');
    if (!targets.length) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const section = entry.target;
          const bg = section.previousElementSibling;
          if (entry.isIntersecting) {
            section.classList.add('is-visible');
            if (bg && bg.classList.contains('section-bg--animate')) {
              bg.classList.add('is-visible');
            }
          } else {
            section.classList.remove('is-visible');
            if (bg && bg.classList.contains('section-bg--animate')) {
              bg.classList.remove('is-visible');
            }
          }
        });
      },
      { threshold: 0.15 }
    );
    targets.forEach((el) => observer.observe(el));
  })();
  } catch(e) { console.error(e); }
})();

})();
